import "styles/pages/page-career.scss";
import React, { useState } from "react";
import { graphql } from "gatsby";

import Layout from "components/Layout";
import Seo from "components/Seo";
import SubpageHeader from "components/SubpageHeader/SubpageHeader";
import SectionHeader from "components/SectionHeader/SectionHeader";
import CareerTile from "components/CareerTile/CareerTile";
import TeamPersonTile from "components/TeamPersonTile/TeamPersonTile";
import ContactForm from "../components/ContactForm/ContactForm";

const CareerPage = ({ location, data, pageContext }) => {
  const allCareers = data.allWpCareer.nodes;
  const seo = pageContext.seo;
  const careerPage = pageContext.pageContent;
  const [recipient, setRecipient] = useState("");
  const [newRecipient, setNewRecipient] = useState(false);
  const onReset = () => {
    setRecipient("");
  };
  return (
    <Layout>
      <Seo title={seo.title} description={seo.metaDesc} />
      <SubpageHeader
        title={careerPage.mainTitle}
        subtitle={careerPage.subTitle}
        location={pageContext.title}
      />
      <section className="career-about">
        <div className="container">
          <div
            className="career-about__text"
            dangerouslySetInnerHTML={{ __html: careerPage.desc }}
          />
        </div>
      </section>
      <section className="career-offers">
        <div className="container">
          <SectionHeader
            title={`Aktualne oferty pracy (${allCareers.length})`}
            variant="singleBig"
          />
          <div className="career-offers__offers-container">
            {allCareers?.map((node, index) => {
              return (
                <CareerTile
                  key={index}
                  jobName={node.singleCareer.title}
                  description={node.singleCareer.shortDesc}
                  image={node.singleCareer.image.sourceUrl}
                  link={node.uri}
                  date={node.date}
                />
              );
            })}
          </div>
        </div>
      </section>
      <section className="career-team">
        <div className="container">
          {careerPage.team?.map((node, index) => {
            return (
              <div key={index}>
                <SectionHeader
                  title={node.bigHeader}
                  subtitle={node.smallHeader}
                  reversed={true}
                />
                <div className="row justify-content-center">
                  {careerPage.team[index].persons?.map((person, index) => {
                    return (
                      <div className="col-xl-3 col-md-4 col-sm-6" key={index}>
                        <TeamPersonTile
                          name={person.singleTeam.fullname}
                          jobName={person.singleTeam.jobname}
                          avatar={person.singleTeam.avatar?.sourceUrl}
                          phone={person.singleTeam.phone}
                          email={person.singleTeam.email}
                          onClick={(e) => setRecipient(person.singleTeam.email)}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </section>
      <span className="anchor" id="formularz"></span>
      <section className="career-contact">
        <div className="container">
          <ContactForm
            subject="KARIERA"
            selectedEmail={recipient}
            onReset={onReset}
          />
        </div>
      </section>
    </Layout>
  );
};

export const query = graphql`
  query jobsListCareerPage {
    allWpCareer {
      nodes {
        title
        uri
        slug
        date(formatString: "DD MMMM, YYYY", locale: "pl")
        singleCareer {
          title
          image {
            sourceUrl
          }
          shortDesc
        }
      }
    }
  }
`;

export default CareerPage;
